if(!customElements.get('products-filter')){
    class ProductsFilter extends HTMLElement {
        constructor() {
          super();
      
          this.buttonsFilter = Array.from(this.querySelectorAll('.products-filters_container button'));
          this.productsItemsContainer = this.querySelector('#products');
          this.productsItems = this.querySelectorAll('#products .products__block-card-item');
      
          this.buttonsFilter.forEach((button) => {
            button.addEventListener('click', () => {
              this.filterItemsByCategory(button);
            });
          });
        }
      
        filterItemsByCategory(button) {
          const category = button.id;

          this.productsItems.forEach((item) => {
            if (item.dataset.categoryId === category) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
            }
          });
      
          this.setActiveButton(button);
          this.updateSwiper();
        //   this.scrollToTop();
        }
      
        setActiveButton(activeButton) {
          const btnRemoveActive = this.buttonsFilter.find((button) => button.classList.contains('active'));
      
          btnRemoveActive.classList.remove('active');
      
          activeButton.classList.add('active');
        }

        updateSwiper() {
          this.productsItemsContainer.swiper.update();
        }
      
        scrollToTop() {
          this.productsItemsContainer.scrollIntoView({
            behavior: 'smooth',
          });
        }
      }
      
      customElements.define('products-filter', ProductsFilter);
}